import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import PostbackPage from '@pages/postback/ui/PagePostback';

export const Route = createFileRoute('/_auth/_layout/postback')({
  component: PostbackPage,
});
